// @ts-nocheck
/* eslint-disable */
export const appFlagIcon = {
    data: `<svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m70.235 512h-40v-512h451.53l-114.706 156 114.706 156h-411.53zm0-240h332.47l-85.294-116 85.294-116h-332.47z"/></g></svg>`,
    name: 'flag' as const
};